module.exports = __webpack_public_path__ + "img/1625412952916.cbc2cdd3.jpeg";